export class LineChartDataset {

  label!: string;
  data!: any[];
  fill!: boolean;
  borderColor!: string;
  backgroundColor!: string;
  tension!: number;
  pointStyle!: string;
  pointBackgroundColor!: string;
  pointBorderColor!: string;
  pointBorderWidth!: number;
  pointRadius!: number;
  pointHoverRadius!: number;

}
